import { render, staticRenderFns } from "./ProformaLinesEdit.vue?vue&type=template&id=72e20766&scoped=true"
import script from "./ProformaLinesEdit.vue?vue&type=script&lang=ts"
export * from "./ProformaLinesEdit.vue?vue&type=script&lang=ts"
import style0 from "./ProformaLinesEdit.vue?vue&type=style&index=0&id=72e20766&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72e20766",
  null
  
)

export default component.exports